const read_clean_username = (value = '') => {
    return `${value || ''}`.trim().toLowerCase();
};

// Confirms that one canonical Erised username still belongs to the typed prefix.
export const sass_username_matches_typed_prefix = (canonicalUsername = '', typedUsername = '') => {
    const canonicalValue = read_clean_username(canonicalUsername);
    const typedValue = read_clean_username(typedUsername);

    return typedValue.length > 0 && canonicalValue.startsWith(typedValue);
};

// Keeps a previous match valid only while the seller's input remains unchanged.
export const sass_username_match_is_current = (matchState = {}, username = '') => {
    const typedUsername = read_clean_username(username);

    return matchState.status === 'matched'
        && matchState.typedUsername === typedUsername
        && Boolean(matchState.registeredUser?.userId)
        && sass_username_matches_typed_prefix(matchState.registeredUser?.username, typedUsername);
};
